import { useRoute } from "vue-router";

export function useImpersonate() {
  const route = useRoute();

  const startImpersonate = (userId: number | string) => {
    /* 
    vue-router fails to keep track of all the query params when using useTableMemory, so just
    window.location.search is necessary to capture all the params if coming from a table
    */
    localStorage.setItem("IMPERSONATE_SOURCE", route.path + window.location.search);

    window.location.replace(`${import.meta.env.VITE_API_BASE_URL}/internal/impersonate/${userId}`);
  };

  const stopImpersonate = () => {
    window.location.replace(`${import.meta.env.VITE_API_BASE_URL}/internal/unimpersonate`);
  };

  return {
    startImpersonate,
    stopImpersonate
  };
}
